import React from 'react';
import { func, bool, string, array, oneOfType, object } from 'prop-types';
import { Form as UIForm, Message } from 'semantic-ui-react';


const Form = ({
    children,
    error,
    handleSubmit,
    submitting = false,
    submitFailed,
    className,
}) => (
    <UIForm
        onSubmit={handleSubmit}
        loading={submitting}
        error={Boolean(error) || submitFailed}
    >
        <Message
            error
            color="red"
            icon="attention"
            header="Submit Failed"
            content={error}
        />

        <div className={className}>
            { children }
        </div>
    </UIForm>
);


Form.propTypes = {
    children: oneOfType([object, array]).isRequired,
    handleSubmit: func.isRequired,
    submitFailed: bool.isRequired,
    submitting: bool,
    error: string,
    className: string,
};

export default Form;
